function AdminSettingsPoliciesController($scope, $state) {}
AdminSettingsPoliciesController.$inject = ["$scope", "$state"];

export default AdminSettingsPoliciesController;

